export var GLOBAL = {
    //url: 'http://127.0.0.1:4201/api/',
    //url:'http://3.145.36.53:9095/api/'
    //url: 'http://127.0.0.1:9095/api/',
    url: 'https://gironthing.cloud/api/',
}



